import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
export const getMemoryHref = memoryItem => `${getFullUrlWithCurrentSubDomain()}/memories?memoryItem=${encodeURIComponent(memoryItem)}`;
export const buildMemorySourcesSections = ({
  memories,
  title,
  label
}) => {
  if (memories.length === 0) {
    return [];
  }
  return [{
    title,
    sources: memories.map((memoryItem, index) => ({
      id: `memory-${index}`,
      primaryText: label,
      secondaryText: memoryItem,
      data: {
        source: 'MEMORY',
        memoryText: memoryItem,
        __typename: 'com.hubspot.chatspot.message.schemas.sections.sources.MemorySourceData'
      }
    }))
  }];
};
export const isMemorySource = source => {
  var _data;
  const sourceType = source === null || source === void 0 || (_data = source.data) === null || _data === void 0 ? void 0 : _data.source;
  return sourceType === 'MEMORY';
};
const isMessageWithMemoriesUsed = value => typeof value === 'object' && value !== null && 'memoriesUsed' in value;
const isMemoryEntryObject = value => typeof value === 'object' && value !== null && 'memoryItem' in value;
export const extractMemoriesFromMessage = message => {
  if (!isMessageWithMemoriesUsed(message)) {
    return [];
  }
  const rawMemories = Array.isArray(message.memoriesUsed) ? message.memoriesUsed : [];
  return rawMemories.map(memory => {
    if (typeof memory === 'string') {
      return memory;
    }
    if (isMemoryEntryObject(memory)) {
      var _memory$memoryItem;
      return (_memory$memoryItem = memory.memoryItem) !== null && _memory$memoryItem !== void 0 ? _memory$memoryItem : '';
    }
    return '';
  }).filter(memory => memory.length > 0);
};